module.exports = __webpack_public_path__ + "media/img/openedIcon-04677c7adf56f558e192b94010d6aab2.png";